/**
 * 말 속도 (SPEC_CHANGE_v1.3 31장, C-37 · D100). 서버가 별채 · 카운터 · 1:1 응답에 실어 보내는 배수를 기억해,
 * 화면의 순차 공개 간격이 서버 공개 큐와 같은 공식(@config/timing/reveal.js) × 같은 배수를 씁니다. 기본 1.0
 */
import { DEFAULT_REVEAL_SPEED, FIRST_MIN_MS, normalizeSpeed, revealGapMs } from '@config/timing/reveal.js';

let speed = DEFAULT_REVEAL_SPEED;

export function currentRevealSpeed() {
    return speed;
}

/** 응답에 revealSpeed 가 있으면 받아 둠 */
export function noteRevealSpeed(value) {
    if (value !== undefined && value !== null) {
        speed = normalizeSpeed(value);
    }
}

/** 앞에 보인 말과 다음 말 사이(C-37 · D100). 앞 말이 없으면 0. 말은 { body, memberKey } */
export function revealGapOf(prev, next) {
    if (!prev || !next) {
        return 0;
    }
    return revealGapMs({
        prevBody: prev.body,
        nextBody: next.body,
        sameMember: Boolean(prev.memberKey) && prev.memberKey === next.memberKey,
        speed: speed,
    });
}

/** 생성 없이 바로 올리는 첫 말의 최소 간격(답을 기다린 시간이 이미 입력 중이었음) */
export function firstLineWaitMs() {
    return Math.round(FIRST_MIN_MS * speed);
}

/** 동작 줄이기 설정(모션만 없애고 간격은 그대로, 31.2) */
export function prefersReducedMotion() {
    return Boolean(globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
}
